import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import truckIcon from "../../../../assets/icons/truck.png";
import packageIcon from "../../../../assets/icons/package.png";

function ReturnDetail({ localLoading, productDetails }) {
  return (
    <div className="root_return_details">
      {localLoading ? (
        <Skeleton height={30} width={250} count={3} />
      ) : (
        <>
          <div className="details_flx" style={{ marginBottom:"3px"}}>
            <div className="fe-mob">
              <img
                src={truckIcon}
                className="img-truck"
                alt="Free Shipping"
              />
              <span className="txt-sub-info-pdp">Free Shipping</span>
            </div>

            <div>
              <img
                src={packageIcon}
                className="img-exchange"
                alt="Returns"
              />
              <span className="txt-sub-info-pdp">
                {productDetails?.return_exchange_days}
              </span>
            </div>
          </div>

          {productDetails?.sub_category_action_url === "carpet" && (
            <p className="txt-Carpet-Finder">
              Not sure which carpet fits your space? Try our{" "}
              <span className="txt_crp">
                <Link style={{ color: "#000" }}
                  to="/floor-matcher"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Floor Matcher
                </Link>
              </span>
            </p>
          )}
        </>
      )}
    </div>
  );
}

export default ReturnDetail;